import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useContext, useRef } from "react";
import { Toast } from "primereact/toast";
// Create context with undefined as the default value
const ToastContext = createContext(undefined);
// Wrap context provider to add functionality
export const ToastContextProvider = ({ children }) => {
    const toastRef = useRef(null);
    const showToast = (options) => {
        if (!toastRef.current)
            return;
        toastRef.current.show(options);
    };
    return (_jsxs(ToastContext.Provider, { value: { showToast }, children: [_jsx(Toast, { ref: toastRef, position: "top-right" }), _jsx("div", { children: children })] }));
};
export const useToastContext = () => {
    const context = useContext(ToastContext);
    if (!context) {
        throw new Error("useToastContext must be used within ToastContextProvider");
    }
    return context;
};
